/**
 * Topbar — pattern SkillMap V0 (langue + profil + logout).
 */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import i18n from "../../i18n";

export function Topbar() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function toggleLang() {
    const next = i18n.language?.startsWith("fr") ? "en" : "fr";
    void i18n.changeLanguage(next);
    localStorage.setItem("sm_lang", next);
  }

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  const langLabel = i18n.language?.startsWith("fr") ? "EN" : "FR";

  return (
    <header className="sm-topbar">
      <div />
      <div className="sm-topbar-actions">
        <button type="button" className="sm-btn sm-btn-ghost sm-btn-sm sm-lang-btn" onClick={toggleLang}>
          {langLabel}
        </button>
        <button
          type="button"
          className="sm-btn sm-btn-ghost sm-btn-sm"
          onClick={() => navigate("/profile")}
        >
          <span className="sm-topbar-user">{user?.fullName}</span>
        </button>
        <button type="button" className="sm-btn sm-btn-ghost sm-btn-sm sm-logout-btn" onClick={() => void handleLogout()}>
          {t("logout")}
        </button>
      </div>
    </header>
  );
}
